__turbopack_context__.v({
  "anonymousField": "ReviewForm-module-scss-module__cae2nW__anonymousField",
  "attachmentPreview": "ReviewForm-module-scss-module__cae2nW__attachmentPreview",
  "commentControl": "ReviewForm-module-scss-module__cae2nW__commentControl",
  "commentField": "ReviewForm-module-scss-module__cae2nW__commentField",
  "fieldError": "ReviewForm-module-scss-module__cae2nW__fieldError",
  "formError": "ReviewForm-module-scss-module__cae2nW__formError",
  "legalText": "ReviewForm-module-scss-module__cae2nW__legalText",
  "moderationNotice": "ReviewForm-module-scss-module__cae2nW__moderationNotice",
  "moderationRulesButton": "ReviewForm-module-scss-module__cae2nW__moderationRulesButton",
  "overallRating": "ReviewForm-module-scss-module__cae2nW__overallRating",
  "ratingLabel": "ReviewForm-module-scss-module__cae2nW__ratingLabel",
  "reviewForm": "ReviewForm-module-scss-module__cae2nW__reviewForm",
  "starsLarge": "ReviewForm-module-scss-module__cae2nW__starsLarge",
  "submitGroup": "ReviewForm-module-scss-module__cae2nW__submitGroup",
  "successMessage": "ReviewForm-module-scss-module__cae2nW__successMessage",
  "uploadBox": "ReviewForm-module-scss-module__cae2nW__uploadBox",
  "uploadBoxFilled": "ReviewForm-module-scss-module__cae2nW__uploadBoxFilled",
  "uploadButton": "ReviewForm-module-scss-module__cae2nW__uploadButton",
  "uploadControls": "ReviewForm-module-scss-module__cae2nW__uploadControls",
  "uploadEmpty": "ReviewForm-module-scss-module__cae2nW__uploadEmpty",
  "uploadField": "ReviewForm-module-scss-module__cae2nW__uploadField",
  "videoPlayIcon": "ReviewForm-module-scss-module__cae2nW__videoPlayIcon",
});
